// ~ HeRe Be DRaGONs ~
// This file is for code that runs 👹 Globally on window, like Bootstrap, jQuery, and UJS
// This needs to be migrated later, please do not add to it unless supporting legacy jQuery 💘
//
//                               #########
//                     ## ##   ########## #####
//                  ########     #########        #
//                ############       ##########   ####
//             # # ###     #####   ######  ###    ########
//              ##        ############      ######### #####
//        ## ###### ##    ########################      #####
//       ###############  ####### ####################   #####
//      #####      #############    #####################  #####
//     ######         ##########     ######################## ###
//    ### #      ##  ##########################################
//             ####### ##########################################
//    ## #######  ####   ########################################
//    #####  ####  ##### #######################################
//    ####     ### ###### ######################################
//     ###########        ######## ################  ###########
//     ### ### #      ##      ###  ################# ###########
//      ###         ###### ###      ######  ###################
//       ###         ######         ######  ########  ########
//        ####      ####################  #######   #######
//           ###          ###             ######  ########
//                #####             #########   ######
//                   #####################  #######
//                             #   ########
//

import 'jquery-color'
import bootbox from 'bootbox'
import '../styles/legacy.scss'

window.bootbox = bootbox // 👹 Globals: bootbox

export default function legacy() {
  require('../legacy/mvb')
  require('../legacy/shipments')
  require('../legacy/affiliate')
  require('../legacy/consolidations')
  require('../legacy/current_parcel')
  require('../legacy/destination_addresses')
  require('../legacy/fast_buy')
  require('../legacy/optional_line_items')
  require('../legacy/photoswipe')
  require('../legacy/service_requests')
  require('../legacy/users')
}
